import React from "react";
import Avator from "../../../assets/images/Avatar-1.png";
import { useLocation } from "react-router-dom";
import moment from "moment";
const PersonalDetails = () => {
  const { state } = useLocation();
  console.log({ state });

  return (
    <div className="tab-content">
      <div className="tab-pane fade active show" id="PersonalDetails">
        <div className="PersonalDetailsBody">
          <figure>
            <img src={state?.profilePic || Avator} />
          </figure>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Location</th>
                <th>DOB</th>
                <th>Grade</th>
                <th>School</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{state?.fullName}</td>
                <td>{state?.email}</td>
                <td>{state?.phoneNumber}</td>
                <td>{state?.location}</td>
                <td>{state?.dateOfBirth ? moment(state?.dateOfBirth).format("DD-MM-YYYY") : "-"}</td>
                <td>{state?.grade}</td>
                <td>{state?.school}</td>
              </tr>
            </tbody>
          </table>
          <figcaption>
            <h3>Bio Description</h3>
            <p>{state?.bio}</p>
          </figcaption>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
